export const VARIANT_STYLES = {
	circular: 'relative rounded-full w-full h-full block',
	overlay: 'block absolute inset-0 w-full h-full',
	inline: 'inline static',
	text: 'block relative bg-transparent',
	rectangular: 'block relative w-full h-auto',
} as const;
